<template>
  <v-list-group ref="refVListGroup" class="vertical-nav-menu-group text--primary">
    <template #activator>
      <v-list-item-icon v-if="icon">
        <v-icon v-if="!isSvgIcon" size="24px">{{ icon }}</v-icon>
        <svg-icon v-else :iconClass="icon"></svg-icon>
      </v-list-item-icon>
      <v-list-item-title>
        {{ $t(title) }}
      </v-list-item-title>
    </template>

    <slot></slot>
  </v-list-group>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    isSvgIcon: {
      type: Boolean,
      required: false,
      default: false
    }
  },
}
</script>

<style lang="scss">
.app-navigation-menu {
  .v-list-item {
    padding-left: 22px;
    margin-top: 0.375rem;
    height: 44px;
    min-height: 44px;

    .v-list-item__icon {
      margin-top: 0;
      margin-bottom: 0;
      align-self: center;
    }
  }

  @include theme(v-list-group__header) using ($material) {
    &.v-list-item--active {
      background-color: rgba(map-deep-get($material, 'text', 'primary'), map-deep-get($material, 'states', 'selected'));
    }
  }

  .vertical-nav-menu-group {
    & > .v-list-group__header > .v-list-group__header__append-icon .v-icon {
      transform: rotate(-90deg);
    }

    &.v-list-group--active > .v-list-group__header > .v-list-group__header__append-icon .v-icon {
      transform: none;
    }
  }
}
</style>
